import React, { useState, useEffect } from "react";

import { format } from "date-fns";
import { Table } from "react-bootstrap";
import { Redirect } from "react-router";

import Pagination from "react-paginate";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const TableList = (props) => {
  const [values, setValues] = useState("");

  useEffect(() => {
    setValues(props.List);
  }, [props.List]);

  const handlePageChange = (pageNumber) => {
    props.pageChange(pageNumber.selected + 1);
  };
  const [dropdown, setdropdown] = useState({
    value: false,
    id: -1,
  });

  const handleClick = (id) => {
    setdropdown({
      value: id === dropdown.id && true,
      id: id,
    });
  };

  return (
    <div className="table-responsive">
      <Table hover className="overflow-auto borderless">
        <thead style={{ borderBottom: "#F5F5F9" }}>
          <tr className="table-head">
            <td className="">Dispute id</td>
            <td className="">Order id</td>
            <td className="">Created At</td>
            <td className="">Customer</td>
            <td className="">Status</td>
            <td className="">Store</td>
          </tr>
        </thead>
        <tbody>
          {values !== "" &&
            values.map((dispute) => {
              let id = dispute.id;
              return (
                <tr key={dispute.id} onClick={() => handleClick(id)}>
                  <td className="">{dispute.id}</td>
                  <td className="">{dispute.order_id}</td>
                  <td className="">
                    {format(Date.parse(dispute.created_at), "MMM dd, yyyy p")}
                  </td>
                  <td className="">{dispute.customer_name_en}</td>
                  <td>
                    <div className="status-text">{dispute.status}</div>
                  </td>
                  <td className="">{dispute.store_name_en}</td>
                </tr>
              );
            })}
        </tbody>
      </Table>
      {props.pagination?.total_pages && values.length > 0 && (
        <div
          className="d-flex justify-content-center mb-4 w-100"
          style={{ direction: "ltr" }}
        >
          <Pagination
            direction="ltr"
            previousLabel={<FaChevronLeft color="#404553" />}
            nextLabel={<FaChevronRight color="#404553" />}
            pageCount={props.pagination?.total_pages}
            onPageChange={handlePageChange}
            pageRangeDisplayed={2}
            forcePage={parseInt(props?.pagination?.page) - 1}
            containerClassName="pagination"
            pageClassName="ps-3 pe-3 pt-2 pb-2 ms-3 me-3"
            activeClassName={
              "ms-3 me-3 ps-1 pe-1 text-primary border border-primary font-weight-bold rounded bg-white"
            }
            nextClassName="bg-white ps-3 pe-3 pt-2 pb-2"
            previousClassName="bg-white ps-3 pe-3 pt-2 pb-2"
          />
        </div>
      )}
      {dropdown.value && (
        <Redirect
          push
          to={{
            pathname: `/vendor/disputes-detail/${dropdown.id}`,
            state: { name: "view", id: dropdown.id },
          }}
        />
      )}
    </div>
  );
};

export default TableList;
